import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, Trash2 } from 'lucide-react';
import { API } from '@/constants/bluemonk';

export const AdminClientTeamSection = ({ config, headers, onRefresh }) => {
  const [team, setTeam] = useState([]);
  const [newMember, setNewMember] = useState({ id: '', name: '', role: '', email: '' });

  useEffect(() => {
    if (config?.clientTeam) {
      setTeam(config.clientTeam);
    }
  }, [config]);

  const handleSave = async () => {
    try {
      await axios.put(`${API}/admin/config/client-team`, { clientTeam: team }, { headers });
      toast.success('Client team updated');
      onRefresh();
    } catch (error) {
      toast.error('Failed to update');
    }
  };

  const handleAdd = () => {
    if (!newMember.id || !newMember.name || !newMember.email) {
      toast.error('Please fill all required fields');
      return;
    }
    setTeam([...team, newMember]);
    setNewMember({ id: '', name: '', role: '', email: '' });
  };

  const handleRemove = (id) => {
    setTeam(team.filter(m => m.id !== id));
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-900">Client Team</h1>
        <Button onClick={handleSave} className="bg-primary hover:bg-primary/90">
          Save Changes
        </Button>
      </div>

      <Card className="p-6">
        <h2 className="text-lg font-semibold mb-4">Team Members</h2>
        <div className="space-y-3">
          {team.map((member) => (
            <div key={member.id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
              <div>
                <p className="font-medium">{member.name}</p>
                <p className="text-sm text-slate-500">{member.role} • {member.email}</p>
              </div>
              <Button
                size="sm"
                variant="ghost"
                className="text-red-600"
                onClick={() => handleRemove(member.id)}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-6 border-t">
          <h3 className="font-medium mb-4">Add New Member</h3>
          <div className="grid grid-cols-4 gap-4">
            <Input
              placeholder="ID (e.g., john)"
              value={newMember.id}
              onChange={(e) => setNewMember({ ...newMember, id: e.target.value })}
            />
            <Input
              placeholder="Full Name"
              value={newMember.name}
              onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
            />
            <Input
              placeholder="Role"
              value={newMember.role}
              onChange={(e) => setNewMember({ ...newMember, role: e.target.value })}
            />
            <Input
              placeholder="Email"
              value={newMember.email}
              onChange={(e) => setNewMember({ ...newMember, email: e.target.value })}
            />
          </div>
          <Button onClick={handleAdd} className="mt-4">
            <Plus className="h-4 w-4 mr-2" />
            Add Member
          </Button>
        </div>
      </Card>
    </div>
  );
};
